import { Box, Divider } from "@mui/material";
import clsx from "clsx";
import styles from "./Sidebar.module.scss";

interface SidebarSectionProps {
	title?: string;
	className?: string;
	children: React.ReactNode;
	withDivider?: boolean;
}

const SidebarSection = ({ title, className, children, withDivider = false }: SidebarSectionProps) => {
	return (
		<>
			<Box className={clsx(styles.sectionContainer, className)}>
				{title && <Box className={styles.sectionHeader}>{title}</Box>}
				{children}
			</Box>
			{withDivider && <Divider className={styles.sectionDivider} />}
		</>
	);
};

export default SidebarSection;
